import '../styles/Highlight.css';

export default function Highlight() {
  return (
    <section className="highlight">
      <div className='highlight-card'>
      <h2>REÚNETE CON NOSOTROS</h2>
      <p>Estamos orgullosos de los resultados obtenidos y de la satisfacción de nuestros clientes, una realidad que puede comprobarse. Si lo deseas, puedes contactar con nosotros, contarnos tu perfil y hablar previamente con personas con experiencias similares, para que te trasladen de primera mano cómo ha sido trabajar con nosotros. Todo ello de forma completamente gratuita y con un único objetivo: que tomes tu decisión con total confianza.</p>
      <button onClick={() => {
       const form = document.getElementById('contact');
       form.scrollIntoView({ behaviour: 'smooth'});
      }}>Solicitar una cita</button>
      </div>
    </section>
  );
}